export { useHandlePastedFiles } from './useHandlePastedFiles';
